import React, { useEffect, useState } from "react";
import AgentHeader from "../../components/agent-ui/AgentHeader";
import "./dev.css";
import { FormSearch } from "../../utils/utils";
// import ReusableTable from "../../utils/ReusableTable";
import { useNavigate } from "react-router-dom";
import { AxiosAuthGet } from "../../api/api";
import Loading from "../../components/ui/Loading";
import Pagination from "../../utils/pagination";

const DevCustomers = () => {
  const [searchProp, setSearchProp] = useState("");
  const innerWidth = window.innerWidth;
  const [curPage, setCurPage] = useState(1);
  const [estateId, 
    // setEstateId

  ] = useState("");
  const [propId, 
    // setPropId
  ]
     = useState("");
  const [pag, setPag] = useState();
  const [isCusLoad, setIsCusLoad] = useState(false);
  const url = `developer/customers/?search=${searchProp}&estate_id=${estateId}&property_id=${propId}&page=${curPage}&page_size=20`;
  
  const navigate = useNavigate();

  // const [
  //   // propType,
  //    setPropType] = useState("Building");
  const [cusData, setCusData] = useState([]);
  // const [
  //   // estType, 
  //   setEstType] = useState("");
  // const optionsType = [
  //   { value: "All Properties", label: "All Properties" },
  //   { value: "Building", label: "Building" },
  //   { value: "Land", label: "Land" },
  // ];
  // const estateType = [
  //   { value: "All Estates", label: "All Estates" },
  //   { value: "Magodo", label: "Magodo" },
  //   { value: "Ajah", label: "Ajah" },
  // ];

  // const handlePropChange = (value) => {
  //   setPropType(value);
  // };
  const handleSearchChange = (e) => {
    setSearchProp(e.target.value);
    // console.log(e.target.value);
  };
  // const handleEstChange = (value) => {
  //   setEstType(value);
  // };
  const addCus = () => {
    navigate("/dev_dash/customers/add");
  };

  const viewCus = (item) => {
    localStorage.setItem('singleCus', JSON.stringify(item));
    navigate("/dev_dash/customers/view");
  };

  const getCus = () => {
    setIsCusLoad(true);
    AxiosAuthGet(url)
      .then((res) => {
        // console.log(res);
        setCusData(res?.data);
        setPag(res.pagination);
        setIsCusLoad(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsCusLoad(false);
      });
  };

  useEffect(() => {
    getCus();
    // eslint-disable-next-line
  }, [curPage, searchProp]);

  const clickNext = () => {
    setCurPage(pag?.nextPage);
  };
  const clickPrev = () => {
    setCurPage(pag?.previousPage);
  };

  return (
    <div>
      <AgentHeader
        header={"Customers"}
        btnText={"Add Customers"}
        btnClick={addCus}
      />
      <div className="estates_houses" style={{ margin: 0 }}>
        <div className="cus_head">
          <FormSearch
            placeholder={"Search by name, phone, or email..."}
            serStyle={{
              border: "1px solid #73747566",
              width: innerWidth > 900 ? "80%" : "100%",
            }}
            changeInput={handleSearchChange}
          />
          {/* <div className="cus_select">
            <div style={{width: '100%'}}></div>
            <SelectInput2
              options={estateType}
              onChange={handleEstChange}
              labelBg={"transparent"}
            />
            <SelectInput2
              options={optionsType}
              onChange={handlePropChange}
              labelBg={"transparent"}
            />
          </div> */}
        </div>
        <div className="cus_table">
          {isCusLoad && <Loading />}
          {!isCusLoad && (
            <div className="propertiesTableWrapper">
              <table className="propertiesTable">
                <thead>
                  <tr className="propertiesTableHeadRow">
                    <th className="propertiesTableHeadCell">Name</th>
                    <th className="propertiesTableHeadCell">Phone</th>
                    <th className="propertiesTableHeadCell">Email</th>
                    <th className="propertiesTableHeadCell">Estate</th>
                    <th className="propertiesTableHeadCell">Property</th>
                  </tr>
                </thead>
                <tbody className="propertiesTableBody">
                  {cusData?.map((item, idx) => {
                    return (
                      <tr key={idx} onClick={() => viewCus(item)} className="propertiesTableRow">
                        <td className="propertiesTableCell" style={{textTransform: 'capitalize'}}>{item?.name}</td>
                        <td className="propertiesTableCell">
                          {item?.phoneNumber}
                        </td>
                        <td className="propertiesTableCell">{item?.email}</td>
                        <td className="propertiesTableCell">
                          {item?.estate?.name}
                        </td>
                        <td className="propertiesTableCell">
                          {item?.property?.name}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
        {pag && (
          <Pagination
            clickNext={clickNext}
            clickPrev={clickPrev}
            pagData={pag}
          />
        )}
      </div>
    </div>
  );
};

export default DevCustomers;
